export const initShowToggles = () => {
	document.querySelectorAll('.show-toggle').forEach((element) => {
		element.addEventListener('click', (event) => {
			element.parentElement.querySelector('.u-soft-hidden').classList.toggle('u-soft-shown');
		});
	});
};
